import React, { PureComponent, Fragment } from 'react';
import { withNamespaces } from 'react-i18next';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

import Button from '@material-ui/core/Button';

import combineStyles from '../../utils/combineStyles';
import CollapseWrapperStyles from '../../styles/components/collapseWrapper';
import TypographyStyles from '../../styles/typography';
import SpacingStyles from '../../styles/helpers/spacing';
import ButtonStyles from '../../styles/button';
import CommentsSectionStyles from './__styles__/CommentsSection.styles';

import CollapseWrapper from '../Global/CollapseWrapper';

import ActivityList from '../shipment/Activity/ActivityList';
import ActivityModal from '../shipment/Activity/ActivityModal';

import { activities as mockedActivities } from './mockedValues';

const MAX_NUMBER_OF_ACTIVITIES_DISPLAYED = 2;

export class CommentsSection extends PureComponent {
  state = {
    activeNotification: true,
    displayAllActivities: false,
    subscribed: true
  };

  _activeNotificationToggle = () =>
    this.setState({ activeNotification: !this.state.activeNotification });

  _handleOpenActivityModal = () => {
    this.setState({ displayAllActivities: true });
  };

  _handleCloseActivityModal = () => {
    this.setState({ displayAllActivities: false });
  };

  render() {
    const { t, classes } = this.props;
    return (
      <Fragment>
        <CollapseWrapper
          classes={{
            root: classes.root,
            header: classes.panelHeader,
            expandButton: classes.expandButton,
            bodyRoot: classes.collapsePanelBodyRoot
          }}
          header={() => (
            <div className={classes.titleWrapper}>
              <h2 className={classnames(classes.headline8, classes.title)}>
                {t('Activity')}
              </h2>
            </div>
          )}
          body={
            <Fragment>
              <Divider />
              <div className={classes.body}>
                <ActivityList
                  activities={mockedActivities}
                  displayCount={MAX_NUMBER_OF_ACTIVITIES_DISPLAYED}
                />
                <Button
                  variant="outlined"
                  color="primary"
                  className={classnames(
                    classes.outlinedButton,
                    classes.noMarginBottom
                  )}
                  classes={{ label: classes.buttonLabel }}
                  onClick={this._handleOpenActivityModal}
                >
                  {t('View Activity Log')}
                </Button>
              </div>
            </Fragment>
          }
        />
        <ActivityModal
          open={this.state.displayAllActivities}
          onClose={this._handleCloseActivityModal}
          activities={mockedActivities}
        />
      </Fragment>
    );
  }
}

export default withStyles(
  combineStyles(
    CommentsSectionStyles,
    ButtonStyles,
    CollapseWrapperStyles,
    TypographyStyles,
    SpacingStyles
  )
)(withNamespaces()(CommentsSection));
